import { render, staticRenderFns } from "./EnrollPrimeDashboard.vue?vue&type=template&id=3ac4899d&scoped=true&"
import script from "./EnrollPrimeDashboard.vue?vue&type=script&lang=js&"
export * from "./EnrollPrimeDashboard.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/repdashboard.css?vue&type=style&index=0&lang=css&"
import style1 from "./EnrollPrimeDashboard.vue?vue&type=style&index=1&id=3ac4899d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac4899d",
  null
  
)

export default component.exports